import JSEncrypt from 'jsencrypt'

const PUBLIC_KEY = `-----BEGIN PUBLIC KEY-----
MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAlmpJMsFmqJ1aBIkPdo8G
Sg7qL7o3zE6i7oaxNfag6pbl3SMXMBniDsx/zoeQEwmvdKYM+EDMHZ2uiak9/rBu
eeWyzVZAZV9duuAacUdvztMB/jKOPCVXEl4Pzb4kaFEhgy5zfs9vZGTPSqD/qVPC
ODhSG6eLT2YfIgK8CcBVhiTxujhkHjDhUb2HtnJmJ1AXvT5BdSyYlHZl7uzObsW9
eP85YTU26vmJmmD4hKsoMtbuYMHSyhWhuLm2KALEERqxfF7t0agdoWnw/G4sB2pJ
lTZK95n6GQYDaICqOzQZJxKM1GU4xB4Qwb5TxSpxTl7YJOmo/LqsYDc6BEkz3Ipi
nwIDAQAB
-----END PUBLIC KEY-----`

export function generateRequestId() {
  const requestId =
    Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15)
  const timestamp = Date.now()
  return [requestId, timestamp]
}

export function encodeRequestId(requestId, timestamp) {
  const encrypt = new JSEncrypt()
  encrypt.setPublicKey(PUBLIC_KEY)
  const data = `${requestId},${timestamp}`
  return encrypt.encrypt(data)
}
